import React from 'react'
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core'

export default function WYesNoField({data, onChange, tabActive}) {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{data.name}</FormLabel>
      <RadioGroup
        row
        aria-label={data.name}
        name=""
        value={data.value}
        onChange={e => {
          onChange(e, data.key)
        }}
      >
        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
        <FormControlLabel value="no" control={<Radio />} label="No" />
      </RadioGroup>
      <FormHelperText>
        {(() => {
          if (
            (tabActive === 'upcoming' && data.is_required) ||
            (tabActive === 'ongoing' && data.is_required_return)
          ) {
            return 'required*'
          } else {
            return 'optional'
          }
        })()}
      </FormHelperText>
    </FormControl>
  )
}
